import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';

type SellingProductsProps = {
   limit?: number;
};

const useBestSellingProducts = ({ limit }: SellingProductsProps) => {
   const getBestSellingProducts = async () => {
      const { data } = await Axios.get(`hy-providers/v1/dashboard/best-selling-product`, {
         params: {
            limit,
         },
      });
      return data;
   };

   return useQuery(['best-selling-products'], getBestSellingProducts, {
      onError: (error: Error) => {
         sentryCaptureException(error, { tags: { journey: 'business' } });
      },
   });
};

export default useBestSellingProducts;
